import match from '../match';
export default {
  ...match,
  fontVariants() {
    // setting the return to an empty array. This is done in order to nullify fonts, so that
    // the user doesn't download the font from the theme. Instead, the font is being called directly
    // from Google fonts at the html.jsx level (both desktop and mobile) for SiteCode 3 (Japan).
    return [];
  },
  font: {
    monospace: `'Noto Serif JP', Courier, monospace`,
    heading: `'Noto Serif JP', 'Times New Roman', Times, serif`,
    body: `'Noto Serif JP', Helvetica, Arial, sans-serif`,
  },
};
